"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var action_model_1 = require("./model/workflow/action.model");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var path_helper_1 = require("./config/path.helper");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var core_1 = require("@angular/core");
var from_1 = require("rxjs/observable/from");
var operators_1 = require("rxjs/operators");
/**
 * @author by Gor.Hakobyan on 07-Nov-18.
 */
var HttpWorkflowService = /** @class */ (function () {
    function HttpWorkflowService(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.meServiceUri$ = from_1.from(this.applicationPropertiesService.getProperty(path_helper_1.PathHelper.meServiceUriKey));
    }
    HttpWorkflowService_1 = HttpWorkflowService;
    HttpWorkflowService.prototype.getTrackingWorkflowActionsByMasterId = function (indicatorId, valueTypeId, periodicityId, masterId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.get("" + url + path_helper_1.PathHelper.TRACKING_WORKFLOW + indicatorId + "/" + valueTypeId + "/" + periodicityId + "/tracking-data/" + masterId);
        }), operators_1.map(function (response) { return HttpWorkflowService_1.serializeResponse(response); }));
    };
    HttpWorkflowService.prototype.getTrackingWorkflowActionsByIF = function (indicatorId, valueTypeId, periodicityId, rFId, rFItemId, rFLevel, iFSystemName, iFItemId) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.get("" + url + path_helper_1.PathHelper.TRACKING_WORKFLOW + indicatorId + "/" + valueTypeId + "/" + periodicityId + "/tracking-data/" + rFId + "/" + rFItemId + "/" + rFLevel + "/" + iFSystemName + "/" + iFItemId);
        }), operators_1.map(function (response) { return HttpWorkflowService_1.serializeResponse(response); }));
    };
    HttpWorkflowService.prototype.getTrackingWorkflowActionsWithoutIF = function (indicatorId, valueTypeId, periodicityId, rFId, rFItemId, rFLevel) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.get("" + url + path_helper_1.PathHelper.TRACKING_WORKFLOW + indicatorId + "/" + valueTypeId + "/" + periodicityId + "/tracking-data/" + rFId + "/" + rFItemId + "/" + rFLevel);
        }), operators_1.map(function (response) { return HttpWorkflowService_1.serializeResponse(response); }));
    };
    HttpWorkflowService.serializeResponse = function (actions) {
        if (!actions) {
            return null;
        }
        var actionsArr = [];
        for (var _i = 0, actions_1 = actions; _i < actions_1.length; _i++) {
            var action = actions_1[_i];
            var item = new action_model_1.Action(action['id'], action['name'], action['initialStateId'], action['targetStateId']);
            actionsArr.push(item);
        }
        return actionsArr;
    };
    HttpWorkflowService = HttpWorkflowService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpWorkflowService);
    return HttpWorkflowService;
    var HttpWorkflowService_1;
}());
exports.HttpWorkflowService = HttpWorkflowService;
//# sourceMappingURL=http-workflow.service.js.map